module.exports = __webpack_public_path__ + "img/12th_military.853e85a7.webp";